var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-pa-md"},[_c('h5',[_vm._v("Motif: "+_vm._s(_vm.id))]),_c('span',[_vm._v("Type: "+_vm._s(_vm.meta.type))]),_c('FeaturesOfMotif',{attrs:{"motifid":_vm.id}}),_c('SpectrasOfMotif',{attrs:{"motifid":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }